module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAeCAYAAADU8sWcAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEKSURBVHgB7ZXhDYIwEIUPJ8AJrBPoCLiBG6gbuIErOIIbGCeADRwBnAA2qK+RxqahF4NX/GFf8jTkHnxtcwdEkNY6h09wq18qYUVTqIf5aqMvAIBCh3WmiJrBiqmvKDK8YepcTUY43jpw7Ipiy0C8pjPNtqUp1Y+con9QZn6Y3XZZlnX2IpRDpnEyBf7W9J6UB1whUw0SmDnfu+BApnbqJfOs2l/8jASEh5qd3uGCiSmT6bNycOgK5x/kTMacTi4FV8S/JYcWcJSCj9FOGt7AB3iOzjZTtKHw61nZo/+2262UT9D8F3MhtfOLO+tW/Wx3gXuWUvAbU2tCBSl4N6b2q25P8ARP8ASPryeeOGkYmCNZTAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/social-images/linkedin.png
// module id = LnOa
// module chunks = 1